module.exports = __webpack_public_path__ + "c38bf38a7f8d4069b74c4767c42b143b.png";